import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContainerComponent } from './container/container.component';
import { Page1Component } from './page1/page1.component';
import { Page2Component } from './page2/page2.component';
import { ConocenosComponent } from './conocenos/conocenos.component';
import { ContactoComponent} from './contacto/contacto.component'


const routes: Routes = [
  {
    path: 'home',
    component: ContainerComponent
    },
    {
      path: 'home/huarache',
      component: Page1Component
      },
      {
        path: 'home/galletas',
        component: Page2Component
        },
        {
          path: 'home/conocenos',
          component: ConocenosComponent
          },
          {
            path: 'home/contacto',
            component: ContactoComponent
            },
          
    {
      path: '',
      redirectTo: '/home',
      pathMatch: 'full'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
